export { default } from "./FunctionRecordDescription";
